import React from 'react'
import Home from '../container/Home/Home.container'

const HomePage = () => {
  return (
    <Home/>
  )
}

export default HomePage